export enum SourceEnum {
  SHOPIFY = "shopify",
  EXPRESS_CHECKOUT = "expressCheckout",
}
